<template>
  <div>
    <new-formation-popup
      :data-to-show="isNewFormationPopupDisplayed"
      @close="changeStateNewFormationPopup(false)"
      @addFormation="
        (newValue) => {
          addNewFormation(newValue);
        }
      "
      @modifyFormation="
        (newValue) => {
          modifyFormation(newValue);
        }
      "
      :formationToEdit="formations[indexFormationToEdit]"
    />
    <h3 class="my-15 mx-10">Formations</h3>

    <div
      v-if="isErrorMaxLengthDisplayed"
      class="text-pink-600 text-base text-center mb-8"
    >
      Vous ne pouvez pas sélectionner plus d'une formation.
    </div>
    <div
      v-if="isErrorMinLengthDisplayed"
      class="text-pink-600 text-base text-center mb-8"
    >
      Afin d'avoir un rendu visuel optimal, il faut sélectionner exactement une
      formation.
    </div>

    <div v-if="formations.length === 0">
      <h6 class="mx-15 text-gray-600">
        Aucune formation n'a été renseignée sur votre Neopass.
      </h6>
      <h6 class="mx-15 text-gray-600 mt-5">
        Pour mettre en avant vos formations, cliquer sur le bouton "ajouter une
        nouvelle formation"
      </h6>

      <div class="flex justify-center mt-15">
        <action-button
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-indigo-600"
          bg-color-square="bg-indigo-600"
          icon-color="text-white"
          libelle="Ajouter une nouvelle formation"
          :uppercase="true"
          icon="plus-circle"
          type-shadow="indigo-shadow"
          @clickAction="isNewFormationPopupDisplayed = true"
        />
      </div>

      <div class="flex justify-center mt-10">
        <illustration name="evaluation" />
      </div>
    </div>

    <div v-if="formations.length > 0">
      <add-button
        class="mb-8 mx-5 md:mx-10"
        libelle="Ajouter une nouvelle formation"
        @add="isNewFormationPopupDisplayed = true"
      />

      <draggable
        v-model="form.data.formations"
        v-bind="dragOptions"
        @end="drag = false"
        @start="drag = true"
        handle=".handle"
      >
        <transition-group
          enter-active-class="ease-in duration-1000"
          enter-class="bg-indigo-300 border-0 rounded-xl"
          enter-to-class="bg-none border-0 rounded-xl"
          leave-active-class="linear duration-1000"
          leave-class="h-20 opacity-100"
          leave-to-class="h-0 opacity-0"
          tag="div"
        >
          <div
            v-for="(formation, i) in [...formations, ...newFormations]"
            :key="'formation' + i"
            class="grid grid-cols-10 md:gap-x-4 py-5 odd:bg-gray-200 items-center"
            :class="
              formation.value.new ? ' odd:bg-opacity-25' : ' odd:bg-opacity-50'
            "
          >
            <div
              class="col-span-1 md:col-span-2 justify-self-end md:justify-self-center handle"
              :class="formation.value.new ? ' opacity-25' : ''"
            >
              <icon name="move" class="text-indigo-600 w-5 h-5 cursor-move" />
            </div>
            <div class="col-span-6 grid grid-cols-12">
              <div class="col-span-2 h-full flex items-center">
                <CVNewValue
                  class=""
                  v-if="
                    changedFormations[
                      formation.value.type +
                        (formation.value.value.intitule_parcours
                          ? formation.value.value.intitule_parcours
                          : '')
                    ] || formation.value.new
                  "
                  :old="
                    newer.data.parcours[
                      formation.value.type +
                        (formation.value.value.intitule_parcours
                          ? formation.value.value.intitule_parcours
                          : '')
                    ]
                  "
                  @change="
                    (newValue) => {
                      formation.value = replaceValues(
                        formation.value,
                        newValue
                      );
                      newer.data.parcours[
                        formation.value.type +
                          (formation.value.value.intitule_parcours
                            ? formation.value.value.intitule_parcours
                            : '')
                      ] = false;
                    }
                  "
                  @addNew="
                    (newValue) => {
                      importFromNeopass(newValue);
                    }
                  "
                  :right="false"
                  :is-new="formation.value.new"
                />
              </div>

              <div
                class="col-span-10"
                :class="formation.value.new ? ' opacity-25' : ''"
              >
                <p class="text-base font-normal">
                  {{
                    formation.value.value.intitule_parcours
                      ? formation.value.value.intitule_parcours
                      : ''
                  }}
                  {{
                    formation.value.value.duree_formation
                      ? '(' + formation.value.value.duree_formation + ' h)'
                      : ''
                  }}
                </p>
                <p class="text-base font-light">
                  {{ formation.value.type }}
                </p>
                <p class="text-sm italic font-light">
                  {{
                    formation.value.value.debut_parcours
                      ? new Date(
                          formation.value.value.debut_parcours
                        ).toLocaleDateString()
                      : ''
                  }}
                  {{
                    formation.value.value.fin_parcours
                      ? (formation.value.value.debut_parcours ? ' - ' : '') +
                        new Date(
                          formation.value.value.fin_parcours
                        ).toLocaleDateString()
                      : ''
                  }}
                  {{
                    formation.value.value.localisation_parcours
                      ? (formation.value.value.debut_parcours ||
                        formation.value.value.fin_parcours
                          ? ' - '
                          : '') + formation.value.value.localisation_parcours
                      : ''
                  }}
                </p>
              </div>
            </div>

            <div class="col-span-2 flex space-x-3">
              <radio-button
                :name="'formation_' + i + '_display'"
                :value="
                  ((((form || {}).data || {}).formations || [])[i] || {})
                    .isDisplayed || false
                "
                @input="
                  (newValue) => {
                    displayFormation(i);
                  }
                "
                @loseFocus="saveDatas()"
              />
              <div
                v-if="!formation.fromNeopass"
                class="cursor-pointer px-2 relative"
                @click.stop="displayMenuMore(i)"
              >
                <icon name="more-vertical" class="text-pink-600" />
                <div
                  v-if="menuMoreDisplayed === i"
                  v-click-outside="hideMenuMore"
                  class="absolute text-gray-600 bg-white px-5 py-4 rounded-xl shadow-lg flex flex-col space-y-2 text-sm -right-full z-10"
                >
                  <p
                    @click.stop="displayModifyFormationPopup(i)"
                    class="hover:text-gray-900 cursor-pointer"
                  >
                    Modifier
                  </p>
                  <p
                    @click.stop="removeFormation(i)"
                    class="hover:text-gray-900 cursor-pointer"
                  >
                    Supprimer
                  </p>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </draggable>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import draggable from 'vuedraggable';

import NewFormationPopup from './../popup/NewFormationPopup.vue';

import Icon from './../../../components/Icon.vue';
import AddButton from './../../../components/Inputs/AddButton.vue';
import RadioButton from './../../../components/Inputs/RadioButton.vue';

import ActionButton from './../../../components/ActionButton.vue';
import Illustration from './../../../components/Illustration.vue';

import CVNewValue from './CVNewValue';

import Constants from './../../../constants';

export default {
  components: {
    AddButton,
    Icon,
    RadioButton,
    NewFormationPopup,
    draggable,
    ActionButton,
    Illustration,
    CVNewValue,
  },

  data() {
    return {
      isNewFormationPopupDisplayed: false,
      menuMoreDisplayed: -1,
      indexFormationToEdit: -1,
      recursiveMaxDepth: 50,
      recursiveDepth: 0,
      isErrorMaxLengthDisplayed: false,
      isErrorMinLengthDisplayed: false,
    };
  },

  methods: {
    ...mapActions({
      saveDatas: 'curriculumVitae/saveDatas',
    }),

    importFromNeopass(item) {
      delete item.value.new;
      delete this.newer.data.parcours[
        item.value.type +
          (item.value.value.intitule_parcours
            ? item.value.value.intitule_parcours
            : '')
      ];
      this.form.data.formations.push(item);
    },

    changeStateNewFormationPopup(state) {
      if (!state) {
        this.indexFormationToEdit = -1;
      }
      this.isNewFormationPopupDisplayed = state;
    },

    addNewFormation(value) {
      this.form.data.formations.push({
        fromNeopass: false,
        isDisplayed:
          this.hasLimit && this.nbDisplayedFormations >= 1 ? false : true,
        value: {
          type: 'Formation',
          value: value,
        },
      });

      //this.saveDatas();
    },

    displayFormation(index) {
      if (this.hasLimit) {
        if (
          !this.form.data.formations[index].isDisplayed &&
          this.nbDisplayedFormations >= 1
        ) {
          this.isErrorMaxLengthDisplayed = true;
          return;
        }
        if (
          this.form.data.formations[index].isDisplayed &&
          this.nbDisplayedFormations === 1
        ) {
          this.isErrorMaxLengthDisplayed = false;
        }
        if (
          this.form.data.formations[index].isDisplayed &&
          this.nbDisplayedFormations <= 1
        ) {
          this.isErrorMinLengthDisplayed = true;
        }
        if (
          !this.form.data.formations[index].isDisplayed &&
          this.nbDisplayedFormations >= 0
        ) {
          this.isErrorMinLengthDisplayed = false;
        }
      }

      this.form.data.formations[index].isDisplayed =
        !this.form.data.formations[index].isDisplayed;
      this.$forceUpdate();
    },

    displayMenuMore(num) {
      this.menuMoreDisplayed = num;
    },

    hideMenuMore() {
      this.menuMoreDisplayed = -1;
    },

    displayModifyFormationPopup(num) {
      this.indexFormationToEdit = num;
      this.changeStateNewFormationPopup(true);
      this.hideMenuMore();
    },

    removeFormation(num) {
      this.form.data.formations.splice(num, 1);
      //this.saveDatas();
      this.hideMenuMore();
    },

    modifyFormation(newValue) {
      this.form.data.formations[this.indexFormationToEdit].value.value =
        newValue;
      this.indexFormationToEdit = -1;
    },

    mapFormationValues(entry, res = []) {
      if (this.recursiveDepth === this.recursiveMaxDepth) {
        return;
      }
      this.recursiveDepth++;
      for (const key in entry) {
        const type = typeof entry[key];
        if (type === 'object' || type === 'array') {
          res = this.mapFormationValues(entry[key], res);
        } else {
          res.push(entry[key]);
        }
      }
      this.recursiveDepth--;
      return res;
    },

    replaceValues(old, _new) {
      if (!_new) return old;
      switch (_new.constructor) {
        case Object:
          for (const key in _new) {
            const values = this.replaceValues(old[key], _new[key]);
            old[key] = this.replaceValues(old[key], _new[key]);
          }
          break;
        case Array:
          for (const key in _new) {
            if (old[key] === undefined) {
              old[key] = _new[key];
              continue;
            }
            old[key] = this.replaceValues(old[key], _new[key]);
          }
          break;
        default:
          return _new;
      }

      return old;
    },

    *traverse(t) {
      switch (t?.constructor) {
        case Object:
          for (const k in t) yield [k, t[k]], yield* this.traverse(t[k]);

          break;
        default:
          return;
      }
    },
  },

  computed: {
    ...mapGetters({
      form: 'curriculumVitae/form',
      newer: 'curriculumVitae/newForm',
      backdoor: 'app/backdoor',
    }),

    formations() {
      return [...this.form.data.formations];
    },

    changedFormations() {
      let result = {};
      this.formations.forEach((formation) => {
        const type = formation.value.type;
        const intitule = formation.value.value.intitule_parcours
          ? formation.value.value.intitule_parcours
          : '';
        const f = this.newer.data.parcours[type + intitule];
        const mappedValues = this.mapFormationValues(f);
        result[type + intitule] = mappedValues.some((value) => value !== false);
      });

      return result;
    },

    newFormations() {
      let result = [];
      this.backdoor;
      for (const key in this.newer.data.parcours) {
        const formation = { ...this.newer.data.parcours[key] };
        if (
          formation.type === 'Formation initiale' ||
          formation.type === 'Formation professionnelle continue'
        ) {
          formation.new = true;
          result.push({
            fromNeopass: true,
            isDisplayed: false,
            value: formation,
          });
        }
      }
      return result;
    },

    dragOptions() {
      return {
        animation: 500,
        ghostClass: 'bg-indigo-300',
      };
    },

    nbDisplayedFormations() {
      this.backdoor; //for reactivity

      return [...new Set(Object.values(this.formations).flat())].filter(
        (h) => h.isDisplayed
      ).length;
    },

    hasLimit() {
      return [Constants.CV_TYPES.DASHBOARD].includes(this.form.type);
    },
  },

  watch: {
    form: {
      handler() {
        this.saveDatas();
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
